import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faBriefcase } from '@fortawesome/free-solid-svg-icons'; // Import the briefcase icon

const Header = () => {
  return (
    <header>
      <a href="/" className="logo">
        <FontAwesomeIcon icon={faBriefcase} className="portfolio-icon" />ANJALI. {/* Use the portfolio icon */}
      </a>
      <nav className="navbar">
        <ul>
          <li><a href="#contact">contact</a></li>
        </ul>
      </nav>
      <div className="fas fa-bars">
        <FontAwesomeIcon icon={faBars} />
      </div>
    </header>
  );
};

export default Header;
